"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowIssueTypeEnum = exports.RuntimeIssueDto = exports.ControlsSchema = void 0;
exports.isStepCreateBody = isStepCreateBody;
exports.isStepUpdateBody = isStepUpdateBody;
class ControlsSchema {
}
exports.ControlsSchema = ControlsSchema;
class RuntimeIssueDto {
}
exports.RuntimeIssueDto = RuntimeIssueDto;
var WorkflowIssueTypeEnum;
(function (WorkflowIssueTypeEnum) {
    WorkflowIssueTypeEnum["MISSING_VALUE"] = "MISSING_VALUE";
    WorkflowIssueTypeEnum["MAX_LENGTH_ACCESSED"] = "MAX_LENGTH_ACCESSED";
    WorkflowIssueTypeEnum["WORKFLOW_ID_ALREADY_EXISTS"] = "WORKFLOW_ID_ALREADY_EXISTS";
    WorkflowIssueTypeEnum["DUPLICATED_VALUE"] = "DUPLICATED_VALUE";
    WorkflowIssueTypeEnum["LIMIT_REACHED"] = "LIMIT_REACHED";
})(WorkflowIssueTypeEnum || (exports.WorkflowIssueTypeEnum = WorkflowIssueTypeEnum = {}));
function isStepCreateBody(step) {
    return step && typeof step === 'object' && !step._id;
}
function isStepUpdateBody(step) {
    return step && typeof step === 'object' && !!step._id;
}
